module.exports = function iOSVersion() {
  const match = navigator.userAgent.match(/OS (\d+_\d+) like Mac/);

  if (match === null || !match[1]) {
    return undefined;
  }

  return match[1].replace('_', '.');
};
